<template>
  <div class="checkbox-dropdown" :class="{ checked: isChecked }">
    <div class="checkbox-dropdown__header">
      <e-checkbox v-model="isChecked" :disabled="disabled" @update:model-value="onUpdate" />
      <div class="paragraph-m_h font-600" :class="{ 'text-inactive': disabled && !isChecked }" @click="toggle">
        {{ label }}
      </div>

      <e-icon
        v-if="isChecked"
        :name="isOpened ? 'chevronUp' : 'chevronDown'"
        :size="$vuetify.display.smAndDown ? 22 : 24"
        class="ml-1"
        @click="toggle"
      />
    </div>

    <div v-if="isOpened" class="mt-4">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ECheckbox, EIcon } from '@/core/components/ui';

defineProps<{
  label: string;
  disabled?: boolean;
}>();

defineSlots<{
  default: () => void;
}>();

const isChecked = defineModel<boolean>({ required: true });
const isOpened = defineModel<boolean>('opened');

const onUpdate = (value: boolean) => {
  isOpened.value = value;
};

const toggle = () => {
  if (!isChecked.value) {
    return;
  }

  isOpened.value = !isOpened.value;
};
</script>

<style scoped lang="scss">
$root: 'checkbox-dropdown';

.#{$root} {
  &.checked {
    .#{$root} {
      &__header {
        color: $text-link-color;

        cursor: pointer;
        @include hover {
          color: $primary-color;
        }
      }
    }
  }

  &__header {
    display: flex;
    align-items: flex-start;

    width: fit-content;
  }
}
</style>
